import { Link } from 'react-router-dom';
import classes from './index.module.css';

const TITLE = 'Make your final sale items fly off the shelf by making returns possible.';
const descMap = ['Full reimbursement for revenue loss due to customer refunds;', 'Returns are processed and disposed at zero cost to you;', 'Higher conversion. Fewer disputes. Bigger TAM.'];

export default function Intro() {
  // const form = Form.useFormInstance();
  return (
    <div className={classes.intro}>
      <div className={classes.title}>
        {TITLE}
      </div>
      <ul className={classes.desc}>
        {descMap.map((desc) => <li key={desc} className={classes.desc_item}>{desc}</li>)}
      </ul>
      <Link to="../eligible-products"><div className={classes.get_started}>Get started</div></Link>

    </div>

  );
}
